import React, { useState } from 'react';
import api, { setToken } from '../api';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('admin@sparksync.app');
  const [password, setPassword] = useState('admin123');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await api.post('/admin/login', { email, password });
      setToken(data.token);
      onLogin();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.glow} />
      <form onSubmit={submit} className="card" style={styles.card}>
        <div style={styles.brand}>💞 SparkSync</div>
        <h2 style={styles.title}>Admin Panel</h2>
        <p style={styles.sub}>Sign in to manage the platform</p>

        <label style={styles.label}>Email</label>
        <input className="input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@sparksync.app" />

        <label style={styles.label}>Password</label>
        <input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />

        {error ? <div style={styles.error}>{error}</div> : null}

        <button className="btn" type="submit" disabled={loading} style={{ marginTop: 20, width: '100%' }}>
          {loading ? 'Signing in…' : 'Sign In'}
        </button>
        <p style={styles.hint}>Demo: admin@sparksync.app / admin123</p>
      </form>
    </div>
  );
}

const styles = {
  wrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden' },
  glow: { position: 'absolute', width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,77,109,0.35), transparent 70%)', filter: 'blur(40px)' },
  card: { width: 380, position: 'relative', zIndex: 1 },
  brand: { fontSize: 22, fontWeight: 800, textAlign: 'center' },
  title: { margin: '18px 0 4px', textAlign: 'center' },
  sub: { color: 'var(--text-dim)', textAlign: 'center', marginTop: 0, marginBottom: 24, fontSize: 14 },
  label: { display: 'block', color: 'var(--text-dim)', fontSize: 13, fontWeight: 600, margin: '14px 0 6px' },
  error: { color: 'var(--primary)', marginTop: 14, fontSize: 14, fontWeight: 600 },
  hint: { color: 'var(--text-muted)', fontSize: 12, textAlign: 'center', marginTop: 16 },
};
